export type ScopeCategorySlug =
  | 'stationary-combustion'
  | 'mobile-combustion'
  | 'direct-gas-emissions'
  | 'electricity'
  | 'heat'
  | 'cooling'
  | 'fuel-and-energy-related-activities'
  | 'food'
  | 'packaging'
  | 'purchased-goods-and-services'
  | 'scope-1-by-site'
  | 'scope-2-by-site'
  | 'supply-chain-logistics'
  | 'other-purchased-goods'
  | 'capital-goods'
  | 'waste'
  | 'business-travel'
  | 'employee-commuting'
  | 'leased-assets-upstream'
  | 'sold-products-processing'
  | 'sold-products-use'
  | 'sold-products-end-of-life'
  | 'leased-assets-downstream'
  | 'franchises'
  | 'investments';

export type ReportSlugs = Record<string, ScopeCategorySlug>;

export const reportSlugs: ReportSlugs = {
  stationaryCombustion: 'stationary-combustion',
  mobileCombustion: 'mobile-combustion',
  directGasEmissions: 'direct-gas-emissions',
  electricity: 'electricity',
  heat: 'heat',
  purchasedGoodsAndServices: 'purchased-goods-and-services',
  foodAndDrink: 'food',
  packaging: 'packaging',
  cooling: 'cooling',
  fuelAndEnergy: 'fuel-and-energy-related-activities',
  scope1BySite: 'scope-1-by-site',
  scope2BySite: 'scope-2-by-site',
  supplyChainLogistics: 'supply-chain-logistics',
  otherPurchasedGoods: 'other-purchased-goods',
  capitalGoods: 'capital-goods',
  waste: 'waste',
  businessTravel: 'business-travel',
  employeeCommuting: 'employee-commuting',
  leasedAssetsUpstream: 'leased-assets-upstream',
  soldProductsProcessing: 'sold-products-processing',
  soldProductsUse: 'sold-products-use',
  soldProductsEndOfLife: 'sold-products-end-of-life',
  leasedAssetsDownstream: 'leased-assets-downstream',
  franchises: 'franchises',
  investments: 'investments',
};
